module.exports = __webpack_public_path__ + "h5/img/logo3.4e639cec.png";